import { Theme_getDefaultTheme } from "utils/theme"

export const parseTheme = (configTheme: any) => {
    if (typeof configTheme === 'string') return JSON.parse(configTheme)
    if (typeof configTheme === 'object') return configTheme
    return Theme_getDefaultTheme()
}